/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * A flag should be defined for features that require enablement in production only
 * when complete. Once the feature is complete and ready to be exposed in production
 * the flag should be deleted and the code that uses older logic must be deleted
 */

export type FeatureFlag = {
	name: string;
	enabled: boolean;
};

export const FILTERS_FLAG: FeatureFlag = {
	name: 'filtersFlag',
	enabled: true,
};
